import gql from 'graphql-tag';

export const REGION_FIELDS = gql`
  fragment RegionFields on OdProtosFenceData_Region {
    identifier
    tagIdentifiers
    details {
      postalCodes
    }
  }
`;
